// extracted by mini-css-extract-plugin
export default {"dig-Avatar--auto":"StartAccessory_dig-Avatar--auto__2VA+-"};